import { useState, useEffect } from "react";
import Loading from "../../../ui/atoms/loading/Loading";
import Button from "../../../ui/atoms/buttons/Button";
import ChallengeThemeItem from "../components/challenge-theme-item/ChallengeThemeItem";
import DesignParticipatedChallengeItem from "../components/design-participated-challenge/DesignParticipatedChallengeItem";
import { MdQuiz } from "react-icons/md";
import { GoClock } from "react-icons/go";
import ChallengeThemeQuestionItem from "../components/challenge-theme-question-item/ChallengeThemeQuestionItem";
//
import {
  onGetChallengeThemesByStreamIdWithPagination,
  onPickUpChallengeThemeQuestionByIdWithPagination,
} from "../services/challengeTheme";
import { onGetChallengesByUserIdWithPagination } from "../services/challenge";
import { useSelector } from "react-redux";
import moment from "moment";
import { capitalizeAll, isEmpty, wait } from "../../../core/utils/helpers";
import NotFound from "../../../ui/organisms/not-found/404";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../../app/providers/context-provider/useAxiosPrivate";

const ChallengeContent = () => {
  const axiosPrivate = useAxiosPrivate();

  const [isLoading, setIsLoading] = useState(true);
  const [isDesignedChallenge, setIsDesignedChallenge] = useState(true);
  const [isDetailsChallengeTheme, setIsDetailsChallengeTheme] = useState(false);
  const [isMoreChallengeTheme, setIsMoreChallengeTheme] = useState(false);

  const [isDetailsParticipatedChallenge, setIsDetailsParticipatedChallenge] =
    useState(false);

  const [challengeThemesData, setChallengeThemesData] = useState({});
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSelectedChallengeTheme, setCurrentSelectedChallengeTheme] =
    useState({});

  const [challengeQuestionsData, setChallengeQuestionsData] = useState({});
  const questionsRowsPerPage = 10;
  const [questionsCurrentPage, setQuestionsCurrentPage] = useState(1);

  const [challengesData, setChallengesData] = useState({});
  const challengeRowsPerPage = 8;
  const [challengeCurrentPage, setChallengeCurrentPage] = useState(1);

  const navigate = useNavigate();

  const initConnectedUser = useSelector(
    (state) => state.setInitConf.initConnectedUser,
  );
  const _sys_role = initConnectedUser?.sys_role;

  const currentConnectedStream = useSelector(
    (state) => state.setInitConf.currentConnectedStream,
  );
  const current_stream_id = currentConnectedStream?.stream_id;
  const _inscription_id = _sys_role == "student" ? currentConnectedStream?.inscription_id : initConnectedUser?.inscription;

  useEffect(() => {
    const fetchData = async () => {
      await wait(1500);

      let isMounted = true;
      const controller = new AbortController();
      const signal = controller.signal;

      const _localData = {
        stream_id: current_stream_id,
        rows_per_page: rowsPerPage,
        current_page: currentPage,
      };

      onGetChallengeThemesByStreamIdWithPagination(axiosPrivate, _localData, signal).then(
        (response) => {
          const _data = response?.data;
          setChallengeThemesData(_data);
        },
      );

      setIsLoading(false);

      return () => {
        isMounted = false;
        isMounted && controller.abort();
      };
    };
    fetchData();
  }, [rowsPerPage, currentPage]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const localData = {
      is_set: isDesignedChallenge ? "own-sets" : "participated",
      inscription_id: _inscription_id,
      rows_per_page: challengeRowsPerPage,
      current_page: challengeCurrentPage,
    };

    onGetChallengesByUserIdWithPagination(axiosPrivate, localData, signal).then(
      (response) => {
        const _data = response?.data;
        setChallengesData(_data);
      },
    );

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [isDesignedChallenge, challengeRowsPerPage, challengeCurrentPage]);

  const onNavigate = (_to) => {
    const to = _to;
    navigate(`${to}`, { replace: false });
  };

  const onPickUpChallengeQuestions = (row) => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;
    
    const _challenge_id = row?.id;

    const _localData = {
      pick_question_from: "system",
      challenge_id: _challenge_id,
      rows_per_page: questionsRowsPerPage,
      current_page: questionsCurrentPage,
    };
    onPickUpChallengeThemeQuestionByIdWithPagination(axiosPrivate, _localData, signal).then(
      (response) => {
        const _data = response?.data;
        setChallengeQuestionsData(_data);
        //
        setCurrentSelectedChallengeTheme(row);
        setIsDetailsChallengeTheme(true);
      },
    );
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  const onHandleChallengeClicked = (challenge_id) => {
    if (isDesignedChallenge) {
      const to = `/${_sys_role}/challenge/hosting/${challenge_id}`;
      onNavigate(to);
    } else {
      setIsDetailsParticipatedChallenge(true);
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading type={"type-2"} />
      ) : (
        <div className="w-full h-full challenge-content">
          <div className="row-actions">
            <div className="w-20">
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"➕ Create New Challenge"}
                action={() => onNavigate(`/${_sys_role}/challenges/create`)}
              />
            </div>
            <div className="w-20">
              <Button
                type={"button"}
                preferedStyle={"normal"}
                title={"♻️ Join a Challenge"}
                action={() => onNavigate(`/${_sys_role}/challenge/joining`)}
              />
            </div>
          </div>
          {challengeThemesData?.result?.length > 0 && (
            <div className="w-full ch-cont-themes">
              <div className="ch-cont-th-head">
                <h1>Creating new challenge through a theme</h1>
                {challengeThemesData?.result_complements?.total_pages > 1 && (
                  <Button
                    type={"button"}
                    preferedStyle={"normal"}
                    title={"Explore more Challenge Themes..."}
                    action={null}
                  />
                )}
              </div>
              <div className="ch-cont-th-body">
                {challengeThemesData?.result?.map((item, idx) => {
                  return (
                    <ChallengeThemeItem
                      key={idx}
                      data={item}
                      onAction={() => onPickUpChallengeQuestions(item)}
                    />
                  );
                })}
              </div>
            </div>
          )}
          <div className="w-full design-participed-challenges">
            <div className="des-pat-ch-head">
              <div className="w-30 d-flex align-center gap-xs">
                <div className="w-50">
                  <Button
                    type={"button"}
                    preferedStyle={isDesignedChallenge ? "normal" : "default"}
                    title={"Designed Challenges"}
                    action={() => setIsDesignedChallenge(true)}
                  />
                </div>
                <div className="w-50">
                  <Button
                    type={"button"}
                    preferedStyle={!isDesignedChallenge ? "normal" : "default"}
                    title={"Participated Challenges"}
                    action={() => setIsDesignedChallenge(false)}
                  />
                </div>
              </div>
              <div className="w-30">
                <div className="pagination">
                  <div className="p-wrapper">
                    <button
                      className={
                        challengesData?.current_page <= 1
                          ? "button is-inactive"
                          : "button is-active"
                      }
                      onClick={() =>
                        setChallengeCurrentPage((prev) =>
                          prev > 1 ? prev - 1 : 1,
                        )
                      }
                      disabled={challengesData?.current_page <= 1}
                    >
                      Previous
                    </button>
                    <span>
                      Page {challengesData?.current_page} of{" "}
                      {challengesData?.total_pages} pages.
                    </span>
                    <button
                      className={
                        challengesData?.current_page ===
                        challengesData?.total_pages
                          ? "button is-inactive"
                          : "button is-active"
                      }
                      onClick={() =>
                        setChallengeCurrentPage((prev) =>
                          prev <= challengesData?.total_pages ? prev + 1 : prev,
                        )
                      }
                      disabled={
                        challengesData?.current_page ===
                        challengesData?.total_pages
                      }
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="des-pat-ch-body">
              {isEmpty(challengesData?.result) ? (
                <NotFound
                  type={"data"}
                  title={"No Challenge found!"}
                  text={
                    isDesignedChallenge
                      ? "No Designed Challenges available yet!"
                      : "You have not Participated to any challenge yet!"
                  }
                  isBoutton={false}
                />
              ) : (
                challengesData?.result?.map((row, idx) => {
                  return (
                    <DesignParticipatedChallengeItem
                      key={idx}
                      is_designed_challenge={isDesignedChallenge}
                      data={row}
                      onAction={() =>
                        onHandleChallengeClicked(row?.challenge_id)
                      }
                    />
                  );
                })
              )}
            </div>
          </div>
        </div>
      )}
      {/* Challenge Theme */}
      {isDetailsChallengeTheme && (
        <div className="w-full h-full details-challenge-theme fade-in p-xs">
          <div className="w-full h-full dct-wrapper p-xs">
            <div className="dct-head">
              <div className="w-full d-flex justify-space-between">
                <div className="w-fit-content">
                  <h1>
                    {capitalizeAll(currentSelectedChallengeTheme?.title_en)}
                  </h1>
                  <p>
                    {capitalizeAll(
                      currentSelectedChallengeTheme?.challenge_theme_category_title_en,
                    )}
                  </p>
                </div>
                <div className="w-fit-content">
                  <Button
                    type={"button"}
                    preferedStyle={"default"}
                    title={"Close"}
                    action={() => setIsDetailsChallengeTheme(false)}
                  />
                </div>
              </div>
              <div className="w-full d-flex justify-space-between align-center">
                <div className="w-fit-content d-flex gap-lg align-center">
                  <div className="row">
                    <MdQuiz className="icon" />
                    <span>
                      {currentSelectedChallengeTheme?.total_questions}{" "}
                      {currentSelectedChallengeTheme?.total_questions > 1
                        ? "Questions"
                        : "Question"}
                    </span>
                  </div>
                  <div className="row">
                    <GoClock className="icon" />
                    <span>
                      Edited :{" "}
                      {moment(currentSelectedChallengeTheme?.updated_at).format(
                        "LLLL",
                      )}
                    </span>
                  </div>
                </div>
                <div className="w-20">
                  <div className="pagination">
                    <div className="p-wrapper">
                      <button
                        className={
                          challengeQuestionsData?.result_complements
                            ?.current_page === 1
                            ? "button is-inactive"
                            : "button is-active"
                        }
                        onClick={() =>
                          setQuestionsCurrentPage((prev) =>
                            prev > 1 ? prev - 1 : 1,
                          )
                        }
                        disabled={
                          challengeQuestionsData?.result_complements
                            ?.current_page === 1
                        }
                      >
                        Previous
                      </button>
                      <span>
                        Page {questionsCurrentPage} of{" "}
                        {
                          challengeQuestionsData?.result_complements
                            ?.total_pages
                        }{" "}
                        pages.
                      </span>
                      <button
                        className={
                          challengeQuestionsData?.result_complements
                            ?.current_page ===
                          challengeQuestionsData?.result_complements
                            ?.total_pages
                            ? "button is-inactive"
                            : "button is-active"
                        }
                        onClick={() =>
                          setQuestionsCurrentPage((prev) =>
                            prev <=
                            challengeQuestionsData?.result_complements
                              ?.total_pages
                              ? prev + 1
                              : prev,
                          )
                        }
                        disabled={
                          challengeQuestionsData?.result_complements
                            ?.current_page ===
                          challengeQuestionsData?.result_complements
                            ?.total_pages
                        }
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="dct-content">
              {currentSelectedChallengeTheme?.questions?.map(
                (question, idx) => {
                  return (
                    <div className="w-50" key={idx}>
                      <ChallengeThemeQuestionItem
                        index={idx + 1}
                        question_data={{
                          question_id: question?.qv_challenge_theme_question_id,
                          qv_language: question?.qv_language,
                          released_status: question?.is_activated,
                          archived_status: question?.is_deleted,
                          created_at: question?.created_at,
                          type: question?.type,
                          difficulty: question?.difficulty,
                          points: question?.points,
                          timing: question?.timing,
                          random_answer_order: question?.random_answer_order,
                          qv_cover_audio: question?.qv_cover_audio,
                          qv_cover_image: question?.qv_cover_image,
                          qv_description: question?.qv_description,
                          qv_explanations: question?.qv_explanations,
                          qv_answers: question?.qv_answers,
                        }}
                        isCheckBox={true}
                      />
                    </div>
                  );
                },
              )}
            </div>
          </div>
        </div>
      )}
      {isMoreChallengeTheme && (
        <div className="w-full h-full more-challenge-theme fade-in">
          <div className="mct-head">
            <div className="w-20">
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Close"}
                action={() => setIsMoreChallengeTheme(false)}
              />
            </div>
          </div>
          <div className="mct-content"></div>
        </div>
      )}
      {/* Participated Challenge */}
      {isDetailsParticipatedChallenge && (
        <div className="w-full h-full challenge-details-participation fade-in">
          <div className="cdp-head">
            <div className="w-20">
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"Close"}
                action={() => setIsDetailsParticipatedChallenge(false)}
              />
            </div>
          </div>
          <div className="cdp-content"></div>
        </div>
      )}
    </>
  );
};

export default ChallengeContent;
